<template>
<div class="chapter">
<div class="inner_page">
<p><a id="TOC"></a></p>
<div class="ContentsPage">
<h1 id="sigil_toc_id_3">Contents</h1>
<p><span href="#/Text/GPRE" title="Link target outside of Sample">General preface</span></p>
<p><a href="#/Text/PRE">Author’s preface</a></p>
<p><a href="#/Text/ABR">Chief abbreviations</a></p>
<p><a href="#/Text/INT">Introduction: what is this sermon? (5:1, 2)</a></p>
<p><a href="#/Text/CH1">A Christian’s character: the beatitudes (5:3–12)</a></p>
<p><span href="#/Text/CH2" title="Link target outside of Sample">A Christian’s influence: salt and light (5:13–16)</span></p>
<p><span href="#/Text/CH3" title="Link target outside of Sample">A Christian’s righteousness: Christ, the Christian and the law (5:17–20)</span></p>
<p><span href="#/Text/CH4" title="Link target outside of Sample">A Christian’s righteousness: avoiding anger and lust (5:21–30)</span></p>
<p><span href="#/Text/CH5" title="Link target outside of Sample">A Christian’s righteousness: fidelity in marriage and honesty in speech (5:31–37)</span></p>
<p><span href="#/Text/CH6" title="Link target outside of Sample">A Christian’s righteousness: non-retaliation and active love (5:38–48)</span></p>
<p><span href="#/Text/CH7" title="Link target outside of Sample">A Christian’s religion: not hypocritical but real (6:1–6, 16–18)</span></p>
<p><span href="#/Text/CH8" title="Link target outside of Sample">A Christian’s prayer: not mechanical but thoughtful (6:7–15)</span></p>
<p><span href="#/Text/CH9" title="Link target outside of Sample">A Christian’s ambition: not material security but God’s rule (6:19–34)</span></p>
<p><span href="#/Text/CH10" title="Link target outside of Sample">A Christian’s relationships: to his brothers and his Father (7:1–12)</span></p>
<p><span href="#/Text/CH11" title="Link target outside of Sample">A Christian’s relationships: to false prophets (7:13–20)</span></p>
<p><span href="#/Text/CH12" title="Link target outside of Sample">A Christian’s commitment: the radical choice (7:21–27)</span></p>
<p><span href="#/Text/CH13" title="Link target outside of Sample">Conclusion: who is this preacher? (7:28, 29)</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?027f8adb